// AboutUs.js

import Breadcrumbs from "../../01-atoms/breadcrumbs/Breadcrumbs";
import banner from "../../../assets/extras/about-us-banner.jpg";

const AboutUs = () => {
    return (
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <Breadcrumbs />
                
                <div className="content-container">
                    <div className="about-page">

                        <div className="about-page__banner">
                            <img src={banner} width={100} height={100} alt="About Us Banner"></img>
                        </div>

                        <div className="about-page__heading secondary-page__heading">
                            <h2>About Us</h2>
                        </div>

                        <div className="about-page__content">
                            <div>
                                <div className="about-page__subheading">Our Legacy</div>
                                <p>Welcome to Ajit Furniture House, where timeless elegance meets unparalleled craftsmanship. For over four decades, we have been dedicated to providing exceptional furniture and interior design solutions, crafting spaces that reflect the unique tastes and personalities of our valued customers.</p>
                            </div>

                            <div>
                                <div className="about-page__subheading">A Family Tradition</div>
                                <p>Our journey began over 40 years ago when our father laid the foundation of Ajit Furniture House with a vision to redefine the furniture industry. Today, we proudly continue his legacy, driven by the same passion for excellence and commitment to quality that has been ingrained in our family for generations.</p>
                            </div>

                            <div>
                                <div className="about-page__subheading">Quality Craftsmanship</div>
                                <p>At Ajit Furniture House, quality is not just a word — it's a promise we uphold in every piece we create. From the selection of premium materials to the meticulous craftsmanship, we ensure that each furniture item and interior design project meets the highest standards of excellence. Our dedication to quality is reflected in the lasting relationships we've built with our customers over the years, as we strive to exceed their expectations at every turn.</p>
                            </div>

                            <div>
                                <div className="about-page__subheading">Personalized Design Approach</div>
                                <p>We believe that furniture is more than just functional — it's a reflection of one's personality and lifestyle. That's why we take a personalized approach to design, working closely with each client to understand their unique vision and preferences. Whether you're seeking a classic, contemporary, or bespoke design, our team of experienced interior designers is here to bring your dream space to life.</p>
                            </div>
                            
                            <div>
                                <div className="about-page__subheading">Our Motto: Elevate Your Space</div>
                                <p>Our motto is more than just words — it's a philosophy that guides everything we do. "Elevate Your Space, Tailored to Your Taste" encapsulates our commitment to creating personalized, sophisticated interiors that elevate your living environment. With a focus on timeless elegance and precision craftsmanship, we strive to transform your space into a sanctuary of beauty and comfort.</p>
                            </div>
                            
                            <div>
                                <div className="about-page__subheading">Customer Satisfaction</div>
                                <p>We understand that your home is a reflection of your personality and aspirations. That's why we're dedicated to providing exceptional customer service and building lifelong connections with our clients. Your satisfaction is our top priority, and we're here to ensure that every step of your design journey is seamless and enjoyable.</p>
                            </div>

                            <div>
                                <div className="about-page__subheading">Your Design Partner</div>
                                <p>We believe that great design has the power to transform lives. Whether you're furnishing your home or revamping your office space, let us be your partner in creating spaces that inspire and delight. You dream it, and we'll design it — because at Ajit Furniture House, excellence is our tradition, and customer satisfaction is our legacy.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default AboutUs;